import { css } from '@emotion/react'
import { useSelector } from 'react-redux'

import { selectCurrentContactName } from 'ducks/crm/contacts/selectors'
import themeVars from 'ui_theme/site/globals/site.variables'

import useSelectCustomFieldValueForKeyAndType from '../useSelectCustomFieldValueForKeyAndType'

const styles = css`
  min-width: 0;
  flex-grow: 1;

  .name,
  .email {
    font-size: 11px;
    line-height: 17px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .name {
    font-size: 14px;
    font-weight: ${themeVars.graphikWeightMedium};
    line-height: 21px;
  }
  .missing {
    color: var(--color-monochrome-mediumDark);
    display: block;
  }
`

export default function ContactNameAndEmail() {
  const fullName = useSelector(selectCurrentContactName)
  const email = useSelectCustomFieldValueForKeyAndType(
    'contact_email',
    'CONTACT'
  )

  return (
    <div css={styles} className="ContactNameAndEmail">
      <div className="name">{fullName || email || 'Unknown contact'}</div>
      {email && fullName && <div className="email">{email}</div>}
      {!email &&
        (!email && (
          <em className="email missing">No email address provided</em>
        ))}
    </div>
  )
}
